import type { useI18n } from 'vue-i18n';
import { getClientIp } from '@/utils/ip-proxy-utils';

export default defineNuxtPlugin(async (nuxtApp) => {
  const baseUrl = useRuntimeConfig().public.apiUrl;
  const i18n = nuxtApp.$i18n as ReturnType<typeof useI18n>;

  const api = $fetch.create({
    baseURL: baseUrl,
    onRequest: ({ options }) => {
      const requestHeaders = useRequestHeaders();
      for (const [key, value] of Object.entries(requestHeaders)) {
        options.headers.set(key, value);
      }

      if (import.meta.server) {
        const event = useRequestEvent();
        const { clientIp, xff } = getClientIp(event, 'api');
        if (xff) options.headers.set('x-forwarded-for', xff);
        if (clientIp) options.headers.set('x-real-ip', clientIp);
        if (clientIp) options.headers.set('x-client-ip', clientIp);
      }

      options.headers.set('accept', 'application/json');
      options.headers.set('accept-language', i18n.locale.value);
    },

    onResponseError: (ctx) => {
      const code = ctx.response.status;
      const message = i18n.te(`common.error.${code}`) ? i18n.t(`common.error.${code}`) : ctx.response.statusText;

      if (ctx.response.status === 429) {
        throw createError({
          statusCode: code,
          statusMessage: message,
          fatal: true,
          data: {
            showButton: false
          }
        });
      } else if (ctx.response.status >= 500) {
        throw createError({
          statusCode: code,
          statusMessage: message,
          fatal: true,
          data: {
            showButton: true
          }
        });
      }
    }
  });

  nuxtApp.provide('api', api);
});
